import type { FC } from 'react'
import { useState, useContext } from 'react'
import styled from 'styled-components'

import { Button, AlternateButton } from '@/components/DEPRECATED_UI/Button'
import SlideInSidebar from '@/components/DEPRECATED_UI/SlideInSidebar'
import TextAreaInput from '@/components/input/TextAreaInput'
import ctx from '@/context/AppContext'
import { useRemoveAccountantRefereeMutation } from '@/lib/apollo'
import { Colours } from '@/utils/styles'

const ErrorContainer = styled.div`
  strong {
    color: ${Colours.red};
  }
`

interface Props {
  customerId: string
  subjectId: string
  refereeId: string
  onClose: () => void
}

const RemoveAccountantReferenceSidebar: FC<Props> = ({
  customerId,
  subjectId,
  refereeId,
  onClose,
}) => {
  const [comment, setComment] = useState<string>('')

  const { personId } = useContext(ctx)

  const [handleRemoveAccountantReferee, { data, loading, error }] =
    useRemoveAccountantRefereeMutation()

  return (
    <SlideInSidebar
      onClose={onClose}
      header={<h1>Remove accountant referee</h1>}
      content={
        data ? (
          <>This accountant referee has been removed.</>
        ) : (
          <>
            <>Would you like to remove this accountant referee?</>
            <TextAreaInput
              label="Comments"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setComment(e.target.value)
              }}
              value={comment}
            />
          </>
        )
      }
      footer={
        <>
          {error?.message && <ErrorContainer>{error?.message}</ErrorContainer>}
          <div>
            <AlternateButton onClick={onClose}>Cancel</AlternateButton>
            {!data && (
              <Button
                disabled={loading || comment.trim() === ''}
                onClick={() =>
                  handleRemoveAccountantReferee({
                    variables: {
                      customerId,
                      subjectId,
                      userId: personId ?? '',
                      reason: comment,
                      refereeId: refereeId,
                    },
                  })
                }
              >
                Confirm
              </Button>
            )}
          </div>
        </>
      }
    />
  )
}

export default RemoveAccountantReferenceSidebar
